function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Product;
(function(Product) {
    Product["Car"] = "car";
    Product["Pet"] = "pet";
    Product["Life"] = "life";
    Product["Home"] = "home";
    Product["Renters"] = "renters";
    Product["Crypto"] = "crypto";
    Product["HomesiteHomeowners"] = "homesite_homeowners";
})(Product || (Product = {}));
var _obj;
var POLICY_PREFIXES = (_obj = {}, _define_property(_obj, Product.Car, new RegExp(/^LCP[0-9]+-[0-9]+-[0-9]+$/)), _define_property(_obj, Product.Pet, new RegExp(/^LPP[0-9]+-[0-9]+-[0-9]+$/)), _define_property(_obj, Product.Life, new RegExp(/^LLP[0-9]+-[0-9]+-[0-9]+$/)), _define_property(_obj, Product.Home, new RegExp(/^LP[A-Z0-9]+$/)), _define_property(_obj, Product.Renters, new RegExp(/^LP[A-Z0-9]+$/)), _define_property(_obj, Product.Crypto, new RegExp(/^L\$CP[A-Z0-9-]+$/)), _define_property(_obj, Product.HomesiteHomeowners, new RegExp(/^LHHP[A-Z0-9]+$/)), _obj);
function getProductByPolicyId(policyPublicId) {
    if (POLICY_PREFIXES[Product.Car].test(policyPublicId)) return Product.Car;
    if (POLICY_PREFIXES[Product.Pet].test(policyPublicId)) return Product.Pet;
    if (POLICY_PREFIXES[Product.Life].test(policyPublicId)) return Product.Life;
    if (POLICY_PREFIXES[Product.Home].test(policyPublicId)) return Product.Home;
    if (POLICY_PREFIXES[Product.Crypto].test(policyPublicId)) return Product.Crypto;
    if (POLICY_PREFIXES[Product.HomesiteHomeowners].test(policyPublicId)) return Product.HomesiteHomeowners;
    return undefined;
}

export { Product, getProductByPolicyId };
